<section id="locale-menu" class="locale">
  <button mat-button [matMenuTriggerFor]="menu" class="locale__button" data-qa="localSelectButton">
    <span class="locale__selected-text" aria-label="Selected Language Name">{{ locales[locale] }}</span>
    <mat-icon class="locale__icon" id="language-icon" alt="Language Icon" role="img" aria-label="Language">language</mat-icon>
  </button>
</section>

<mat-menu #menu="matMenu" data-qa="localSelectMenu">
  <ng-container *ngFor="let language of languages; trackBy: trackByLanguageFn">
    <button mat-menu-item (click)="chooseLanguage(language)" class="locale__item-button" data-qa="localSelectChooseButton">
      <mat-icon class="locale__selected-icon" [style.visibility]="(reversedLangAbbreviations[language]===locale) ? 'visible' : 'hidden'" role="img" aria-label="Selected Item">done</mat-icon> {{ language | titlecase }}
    </button>
    <p id="powered-by-google-translate" class="locale__powered" *ngIf="reversedLangAbbreviations[language] === 'es-US'">Powered by Google Translate</p>
  </ng-container>
</mat-menu>
